import { apiFetch } from "@/api/client";

export interface ConfiguredClient {
  name: string;
  address: string | null;
  shortname: string | null;
}

export interface ConfiguredClientsResponse {
  items: ConfiguredClient[];
  source_path: string;
}

export interface NasActivitySummary {
  nasipaddress: string;
  session_count: number;
  unique_users: number;
  first_seen: string | null;
  last_seen: string | null;
}

export interface NasActivityListResponse {
  items: NasActivitySummary[];
  total: number;
}

export const fetchConfiguredClients = () =>
  apiFetch<ConfiguredClientsResponse>("/nas/configured");

export const fetchNasActivity = () => apiFetch<NasActivityListResponse>("/nas/activity");
